import {
    FieldInCard,
} from 'app/types/form.types'

import {
    GeneralStatusChangeNote,
    Note,
} from 'app/Apps/ContainerManagement/Containers/components/Overview/ContainerNotes/ContainerNotes.types'

type Params = {
    showOrder?: boolean,
    removeAttachmentsField?: boolean,
}

export const getChangeConfig = (
    {
        showOrder,
        removeAttachmentsField,
    }: Params = {},
): FieldInCard<keyof Note> => {
    const config: FieldInCard<keyof Note> = {
        title: 'CHANGE',
        className: 'change',
        fields:
            [
                {
                    name: 'noteSubject',
                    componentName: 'InputSingleline',
                    labelKey: 'NOTE_SUBJECT',
                },
                {
                    name: 'noteText',
                    componentName: 'LongText',
                    labelKey: 'NOTE_TEXT',
                },

            ],
    }

    if (!removeAttachmentsField) {
        config.fields.push({
            name: 'attachments',
            componentName: 'AttachmentsObjectSelector',
            labelKey: 'ATTACHMENTS',
            disabled: true,
        })
    }
    if (showOrder) {
        config.fields.push({
            name: 'orderId',
            labelKey: 'ORDER',
            componentName: 'OrderLink',
        })
    }
    return config
}

export const AuditTrailConfig: FieldInCard<keyof Note> = {
    title: 'AUDIT_TRAIL',
    className: 'audit',
    fields: [
        {
            name: 'createdBy',
            componentName: 'InputSingleline',
            labelKey: 'CREATED_BY',
        },
        {
            name: 'createdOn',
            componentName: 'DateTimeSelect',
            labelKey: 'CREATED_ON',
            disabled: true,
        },
        {
            name: 'validDateTimestamp',
            componentName: 'DateTimeZonedSelect',
            labelKey: 'VALID_DATE_TIMESTAMP',
        },
    ],
}

export const StatusChangeConfig: FieldInCard<keyof GeneralStatusChangeNote> = {
    title: 'STATUS_CHANGE',
    className: 'Status',
    fields: [{
        name: 'statusChange',
        componentName: 'StatusSelector',
        labelKey: 'STATUS_CHANGE',
    }],
}
